// Based on https://github.com/onderonur/react-infinite-scroll-hook/blob/master/example/examples/InfiniteListWithReverseVerticalScroll.tsx
import { useRef, useCallback } from 'react';

function useScrollPosition() {
  const rootRef = useRef(null);
  const scrollRef = useRef(null);
  const lastScrollDistanceToBottomRef = useRef(0);
  const rootNode = rootRef.current;
  const scrollNode = scrollRef.current;

  // We keep the scroll position when new items are added etc.
  const restoreScrollPosition = useCallback(() => {
    if (rootNode && scrollNode) {
      rootNode.scrollTop = (lastScrollDistanceToBottomRef.current + scrollNode.offsetTop) - (rootNode.offsetHeight + rootNode.offsetTop);
    }
  }, [rootNode, scrollNode]);

  const handleRootScroll = useCallback(() => {
    if (rootNode) {
      lastScrollDistanceToBottomRef.current = (rootNode.offsetTop + rootNode.offsetHeight + rootNode.scrollTop) - scrollNode.offsetTop;
    }
  }, [rootNode, scrollNode]);

  return { restoreScrollPosition, handleRootScroll, rootRef, scrollRef };
}

export default useScrollPosition;
